export default __webpack_public_path__ + "static/media/etaline.8d8ffb17.png";